import { viewChild } from '@angular/core';
import { ACTIVE, INACTIVE, NEEDS_REVIEW } from 'AccountsApp/ts/constants/integrations.constants';
import { SchwabIntegrationService } from 'IntegrationsApp/ts/services/schwab-integration-service';
import { ConfirmModalComponent } from 'Angular/features/components/modals/confirm-modal/confirm-modal.component';
import * as i0 from "@angular/core";
import * as i1 from "IntegrationsApp/ts/services/schwab-integration-service";
import * as i2 from "../../../../../../../../../../../ycharts/static/ts/features/components/modals/confirm-modal/confirm-modal.component";
import * as i3 from "Angular/features/directives/image/image.directive";
import * as i4 from "../../../../../../features/schwab-activate-modal/schwab-activate-modal.component";
import * as i5 from "../integration-status-indicator/integration-status-indicator.component";
const _c0 = ["schwabActivateModalComponent"];
const _c1 = ["schwabDeactivateModalComponent"];
const _c2 = ["ycn-schwab-integration-list-item", ""];
export class SchwabIntegrationListItemComponent {
    constructor(schwabIntegrationService) {
        this.schwabIntegrationService = schwabIntegrationService;
        this.schwabActivateModalComponent = viewChild.required('schwabActivateModalComponent');
        this.USER = window.USER;
        this.status = '';
        this.errorMessage = '';
    }
    ngOnInit() {
        this.updateStatus();
    }
    updateStatus() {
        this.status = '';
        this.schwabIntegrationService.getSchwabIntegrationStatus().subscribe({
            next: (data) => {
                if (data.isActive) {
                    this.status = ACTIVE;
                }
                else if (!data.isActive && data.errorMessage === null) {
                    this.status = INACTIVE;
                }
                else if (!data.isActive && data.errorMessage !== null) {
                    this.status = NEEDS_REVIEW;
                    this.errorMessage = data.errorMessage;
                }
            },
            error: (errorResponse) => {
                this.status = NEEDS_REVIEW;
                this.errorMessage =
                    errorResponse?.error?.errorMessage ||
                        'There was an error activating this integration, please log in again.';
            },
        });
    }
    onActivateDeclined() {
        this.status = INACTIVE;
    }
    deactivateHandler(confirmed) {
        if (confirmed) {
            this.schwabIntegrationService.deactivateSchwabOAuthIntegration().subscribe((res) => {
                if (res.status === 200) {
                    this.updateStatus();
                }
            });
        }
    }
    updateStatusOnWindowFocus() {
        if (!document.hidden) {
            this.updateStatus();
        }
    }
    activateToggle() {
        if (this.status === ACTIVE) {
            this.schwabDeactivateModalComponent.openModal();
        }
        else {
            this.status = ACTIVE;
            this.schwabActivateModalComponent().openModal();
        }
    }
}
SchwabIntegrationListItemComponent.ɵfac = function SchwabIntegrationListItemComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || SchwabIntegrationListItemComponent)(i0.ɵɵdirectiveInject(i1.SchwabIntegrationService)); };
SchwabIntegrationListItemComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: SchwabIntegrationListItemComponent, selectors: [["tr", "ycn-schwab-integration-list-item", ""]], viewQuery: function SchwabIntegrationListItemComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuerySignal(ctx.schwabActivateModalComponent, _c0, 5);
        i0.ɵɵviewQuery(_c1, 5);
    } if (rf & 2) {
        i0.ɵɵqueryAdvance();
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.schwabDeactivateModalComponent = _t.first);
    } }, inputs: { clientId: "clientId", oauthUrl: "oauthUrl", redirectUri: "redirectUri" }, standalone: false, attrs: _c2, decls: 17, vars: 10, consts: [["schwabActivateModalComponent", ""], ["schwabDeactivateModalComponent", ""], [1, "table-logo"], ["ycnImage", "", 3, "imageSrc"], [1, "text-bold"], [3, "errorMessage", "status"], [1, "text-right"], [1, "custom-control", "custom-switch"], ["type", "checkbox", 1, "custom-control-input", 3, "change", "checked"], [1, "custom-control-indicator"], [3, "declined", "clientId", "oauthUrl", "redirectUri"], [3, "confirmHandler", "confirmButtonText", "confirmHeader", "confirmText"]], template: function SchwabIntegrationListItemComponent_Template(rf, ctx) { if (rf & 1) {
        const _r1 = i0.ɵɵgetCurrentView();
        i0.ɵɵelementStart(0, "td")(1, "div", 2);
        i0.ɵɵelement(2, "img", 3);
        i0.ɵɵelementStart(3, "div", 4);
        i0.ɵɵtext(4, "Schwab Advisor Center\u00AE & iRebal");
        i0.ɵɵelementEnd()()();
        i0.ɵɵelementStart(5, "td");
        i0.ɵɵtext(6, "Portfolio Holdings");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(7, "td");
        i0.ɵɵelement(8, "ycn-integration-status-indicator", 5);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(9, "td", 6)(10, "label", 7)(11, "input", 8);
        i0.ɵɵlistener("change", function SchwabIntegrationListItemComponent_Template_input_change_11_listener() { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.activateToggle()); });
        i0.ɵɵelementEnd();
        i0.ɵɵelement(12, "span", 9);
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(13, "ycn-schwab-activate-modal", 10, 0);
        i0.ɵɵlistener("declined", function SchwabIntegrationListItemComponent_Template_ycn_schwab_activate_modal_declined_13_listener() { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.onActivateDeclined()); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(15, "ycn-confirm-modal", 11, 1);
        i0.ɵɵlistener("confirmHandler", function SchwabIntegrationListItemComponent_Template_ycn_confirm_modal_confirmHandler_15_listener($event) { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.deactivateHandler($event)); });
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("imageSrc", "integrations/images/schwab-logo.png");
        i0.ɵɵadvance(6);
        i0.ɵɵproperty("errorMessage", ctx.errorMessage)("status", ctx.status);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("checked", ctx.status === "active");
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("clientId", ctx.clientId)("oauthUrl", ctx.oauthUrl)("redirectUri", ctx.redirectUri);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("confirmButtonText", "Deactivate")("confirmHeader", "Deactivate Schwab Integration")("confirmText", "Are you sure you would like to deactivate your integration with Schwab Advisor Center\u00AE? You will not be able to use this integration unless you reactivate it.");
    } }, dependencies: [i2.ConfirmModalComponent, i3.ImageDirective, i4.SchwabActivateModalComponent, i5.IntegrationStatusIndicatorComponent], encapsulation: 2 });
